var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{attrs:{"right":"","no-caret":""}},[_c('template',{slot:"button-content"},[_c('i',{staticClass:"fa fa-angle-down"})]),_vm._v(" "),_c('b-dropdown-item',{on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fa fa-sign-out"}),_vm._v(" ログアウト")])],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f20dd4d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/HeaderDropdown.vue
// module id = null
// module chunks = 